export default "__VITE_ASSET__BJcu47Pe__"